// preloader.js
// renders prelaoder
import React from "react";
import appConfig from "../../utils/appConfig";
import { Suspense } from "react";
import PreLoaderAnimation from "../preLoaderAnimation/preLoaderAnimation";
import MainRouter from "../routing/mainRouter";
export default function PreLoader(props) {
  if (appConfig.preLoaderAnimation.halt) {
    return <PreLoaderAnimation />;
  } else {
    return (
      <Suspense fallback={<PreLoaderAnimation />}>
        <MainRouter />
      </Suspense>
    );
  }
}
